import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import Campaign from '../../propTypes/Campaign';
import CampaignContext from './CampaignContext';

const CampaignProvider = ({ campaign, children }) => {
  const { current: value } = useRef(campaign);

  return (
    <CampaignContext.Provider value={value}>
      {children}
    </CampaignContext.Provider>
  );
};

CampaignProvider.defaultProps = {
  campaign: undefined,
};

CampaignProvider.propTypes = {
  campaign: PropTypes.shape(Campaign),
  children: PropTypes.node.isRequired,
};

export default CampaignProvider;
